import { Component, ElementRef, Inject, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AskOurDocsV2Service } from '@app/core/services/ask-our-docs-v2/ask-our-docs-v2.service';
import { ChatWrapperComponent } from '@app/shared/components/chat-wrapper/chat-wrapper.component';
import { ContextMenuComponent } from '@app/shared/components/context-menu/context-menu.component';
import { getModelList } from '@app/shared/components/prompt-settings/prompt-settings.data';
import { ContextMenuItem } from '@app/shared/components/context-menu/context-menu';
import { RepoChatDropdownMenuLabels } from '@app/shared/models/repo-chat-dropdown-menu.model';
import { KmdAccordionComponent, KmdModalService, KmdPopoverComponent, KmdTabsComponent } from 'gds-atom-components';
import { ClipboardService } from 'ngx-clipboard';
import { BehaviorSubject, filter, finalize, forkJoin, map, mergeMap, Observable, tap } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { Conversation, ChatMessage } from '@app/shared/models/ask-our-docs-v2.model';
import { DrawerComponent } from '@app/drawer/drawer.component';
import { featureFlags } from "@app/environments/environment";
import { AskOurDocsV2ChatHistoryComponent } from '../modals/ask-our-docs-v2-chat-history/ask-our-docs-v2-chat-history.component';
import { AskOurDocsV2SavedPromptsComponent } from '../modals/saved-prompts/saved-prompts.component';
import { AskOurDocsV2SavePromptComponent } from '../modals/save-prompt/save-prompt.component';
import { PromptPageComponent } from '../prompt-page/prompt-page.component';
import { GroupMembershipService } from '@app/core/services/group-membership/group-membership.service';
import { AskOurDocsService } from '@app/core/services/ask-our-docs/ask-our-docs.service';
import { PromptInputConfig } from '@app/shared/components/prompt-input-new/prompt-input-new';
import { WindowRef } from '@app/core/services/window/window-ref.service';
import { defaultFileManagerConfig } from '@app/shared/components/file-manager/file-manager';
import { CitationViewer } from '../utils/citationViewer.util';
import { AuthService } from "@services/auth/auth.service";

@Component({
  selector: 'app-ask-our-docs-chat-page',
  templateUrl: './ask-our-docs-chat-page.component.html',
  styleUrls: ['./ask-our-docs-chat-page.component.css', '../../chat/chat.component.markdown.css']
})
export class AskOurDocsChatPageComponent implements OnInit  {
  @ViewChild('headerTemplate', { static: true }) headerTemplate: TemplateRef<any> | undefined;
  @ViewChild('headerContainer', { static: true }) headerContainer: ElementRef | undefined;
  @ViewChild('accordion', { static: false }) accordion!: KmdAccordionComponent;
  @ViewChild(DrawerComponent) drawerComponent!: DrawerComponent;
  @ViewChild('tabsComponent') tabsComponent!: KmdTabsComponent;

  @ViewChild(ChatWrapperComponent) chatWrapperComponent!: ChatWrapperComponent;
  @ViewChild('modelContextMenu') modelDropdown!: ContextMenuComponent;
  @ViewChild('popOver1') popover!: KmdPopoverComponent;
  @ViewChild('chatHistoryComponent') chatHistoryComponent! : AskOurDocsV2ChatHistoryComponent
  @ViewChild('savedPromptsComponent') savedPromptsComponent!: AskOurDocsV2SavedPromptsComponent;
  @ViewChild('savePromptComponent') savePromptComponent!: AskOurDocsV2SavePromptComponent;
  @ViewChildren('responseBox') responseBoxes!: QueryList<ElementRef>;
  @ViewChild('promptPage') promptPage!: PromptPageComponent;
  showModelDropdown: boolean = false;
  modelList: ContextMenuItem[] = [];
  aodUrl: string = 'ask-our-docs-version2/';
  id: string = '';
  isUserAdmin: boolean = false;
  repositoryGroup: string = '';
  repoDetails: any = {};
  userName: string = '';
  userEmail: string = '';
  repositoryName: string = '';
  enableCitationDownload: boolean = true;
  repoOwner: string = 'No admin details available';
  internal_index_name: string = '';
  isChatInitiated: boolean = false;
  currentCitations: any = null;
  isExpanded = false;
  expandedIndex: number | null = null;
  last_run_date: string = 'No last run date available';
  repositorydetails: string = 'No information available';
  internalIndexName: string ="";
  linkrequired: boolean = false;
  repositorylink: string = 'No repository link available';
  answerHelpful: boolean = false;
  selectedFeedback: string | null = null;
  position: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'bottom';
  chatHistoryVisible: boolean = false;
  savedPromptsVisible: boolean = false;
  isAppDrawerOpen = false;
  enable_tile: boolean = true;
  searchText: string = '';
  isPublicSavedPromptsEnabled: boolean = false;
  isDetailModalOpen: boolean = false;
  state: any;
  responseGeneratedFlag: boolean = false;

  promptInputConfig: PromptInputConfig = {
    features: {
      addFiles: false,
      changeModel: false,
      agentRating: false,
      webSearchToggle: false,
      copyPasteImages: false
    },
    display: {
      promptSettings: false
    },
    fileManagerConfig: defaultFileManagerConfig
  }

  repoGroupsDictionary: Array<{ key: string, id: string }> = [];
  repoOwnersDictionary: Array<{ key: string, owners: string, isAdmin: boolean }> = [];
  isInfoLoading = true;
  hasRepositories = false;
  isUserRepoAdmin = false;

  protected readonly featureFlags = featureFlags;

  constructor(
    private authService: AuthService,
    private router: Router,
    private askOurDocsV2Service: AskOurDocsV2Service,
    private route: ActivatedRoute,
    private clipboard: ClipboardService,
    private kmdModalService: KmdModalService,
    private groupMembershipService: GroupMembershipService,
    private askOurDocsService: AskOurDocsService,
    @Inject('AOD_SUPER_ADMIN_ID') private aodSuperAdminId: string
  ) {
    this.specificText$.subscribe(value => {
      this.specificText = value;
    });
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.state = navigation.extras.state as {
        id: string;
        isUserAdmin: boolean;
        repositoryGroup: string;
        repositoryName: string;
        isNavigationSourceListingPage: boolean;
      };
      this.id = this.state.id;
      this.isUserAdmin = this.state.isUserAdmin;
      this.repositoryGroup = this.state.repositoryGroup;
      this.repositoryName = this.state.repositoryName;
      this.state.isNavigationSourceListingPage = false;
    } else {
      this.loadRepositoryData();
    }
  }

  loadRepositoryData() {
    const repoId = this.extractLastSegmentRepoId();
    const cleanedRepoName = repoId.replace("dpe_geneai_index_", "");
    const normalizedRepoName = cleanedRepoName.replace(/_/g, ' ');
    this.repositoryName = normalizedRepoName;
    const initialRepositories$ = this.askOurDocsService.pagedRoleRepositories(normalizedRepoName, 0, 1, "All repositories");
    initialRepositories$.subscribe((repositories:any) => {
      this.isUserAdmin = repositories.content[0].isAdmin;
      this.state = {
        id: repositories.content[0].id,
        isUserAdmin : repositories.content[0].isAdmin,
        repositoryName: repositories.content[0].name,
        isNavigationSourceListingPage: false
      }
      this.setEachRepositoriesOwners(repositories);
      this.modelListPopulate();
    });
  }

  userFeedbackFormSubmitted(): void {
    const data = {
        "conversation": this.conversation.messages,
        "conversationId": this.conversation.id,
        "indexName": this.repoDetails.internal_index_name,
        "promptCount": this.conversation.messages.filter(msg => msg.role === 'user').length,
        "title": featureFlags.clickableChatHistory ? this.conversation.messages[0].content.slice(0, 120) : this.conversation.messages[0].content.slice(0, 20)
      };
      this.askOurDocsV2Service.saveToDB(data);
    }

  showFeedbackForm(assistantPromptValue: ChatMessage, answerHelpful: boolean): void {
    assistantPromptValue.showFeedbackForm = true;
    assistantPromptValue.selectedFeedback = answerHelpful ? 'useful' : 'notUseful';
    this.answerHelpful = answerHelpful;
  }

  closeFeedbackForm(assistantPromptValue: ChatMessage): void {
    assistantPromptValue.showFeedbackForm = false;
  }

  ngOnInit() {
    this.id = this.extractLastSegmentRepoId();
    this.id = decodeURIComponent(this.id);
    this.askOurDocsV2Service.getDetails(this.id).then(response => {
      this.repoDetails = response;
      this.isPublicSavedPromptsEnabled = this.repoDetails.suggestions_as_saved_prompts;
      this.enable_tile = this.repoDetails.enable_tile;
      this.enableCitationDownload = this.repoDetails.enable_citation_download;
      this.repoOwner = this.repoDetails.repo_admin;
      this.internal_index_name = this.repoDetails.internal_index_name;
      this.repositorydetails = this.repoDetails.repo_description;
      this.linkrequired = this.repoDetails.enable_repository_link;
      this.repositorylink = this.repoDetails.repository_link;
      this.internalIndexName = this.repoDetails.internal_index_name;
      return this.askOurDocsV2Service.getLastRunDate(this.internal_index_name + '-indexer');
    }).then((response : any) => {
      this.last_run_date = response.last_run_date;
      this.modelList.forEach(item => {
        if (item.id === "3") {
          item.description = this.last_run_date;
        }
      });
    }).catch(e => {
      console.log(e);
    });

    this.authService.userData$.subscribe((result) => {
      this.userName = result.name;
      this.userEmail = result.email;
    });
    this.modelListPopulate();
  }

  modelListPopulate() {
    this.modelList = getModelList().map(model => {
      return {
        id: model.model,
        label: model.model,
        description: model.description
      }
    })
    this.modelList = [
      {
        id: "2",
        label: "History",
        description: "See all chat history with the repository",
        imageUrl: "../../../../assets/icons/clock/clock-24px-mono-new.svg"
      },
      {
        id: "3",
        label: "Source updated:",
        description: `${this.last_run_date}`,
        imageUrl: "../../../../assets/icons/ask-our-docs/calendar-mono.svg"
      },
      {
        id: "4",
        label: "About repository",
        description: "",
        imageUrl: "../../../../assets/icons/info/info-mono.svg"
      }
    ]

    if (this.isUserAdmin) {
      this.modelList.push({
        id: "5",
        label: "Repository settings",
        description: "Edit your configuration, manage users",
        imageUrl: "../../../../assets/icons/ask-our-docs/settings-mono.svg"
      })
    }

    if(featureFlags.savePrompt === true){
      this.modelList.push({
        id: "1",
        label: "Prompt library",
        description: "See prompt suggestions created by the admin(s).",
        imageUrl: "../../../../assets/icons/ask-our-docs/save-mono.svg"
      });
    }

    if(featureFlags.newChat === false){
      this.modelList.unshift({
        id: "0",
        label: "New Chat",
        imageUrl: "../../../../assets/icons/chat/chat-mono.svg"
      });
    }

    this.modelList.sort((a:any,b:any)=> {return a.id - b.id})
  }


  setPrompt(prompt: any) {
    this.chatWrapperComponent.setPromptText(prompt);
  }

  onTabOpen() {
    this.isExpanded = true;
  }

  onTabClose() {
    this.isExpanded = false;
  }

  responseMessage$ = new BehaviorSubject<string>(''); // To track the first response message
  citations$ = new BehaviorSubject<any[]>([]); // To track citations
  intent$ = new BehaviorSubject<string>(''); // To track intent
  specificText$ = new BehaviorSubject<string>(''); // To track specific text
  referenceCount$ = new BehaviorSubject<number>(0); // To track reference count
  referenceLinks$ = new BehaviorSubject<string[]>([]); // To track reference links
  isFirstChunk = true; // To track if it's the first chunk
  specificText: string = ''; // Local variable to bind to template
  userPrompt: string = ''; // To Store user prompt
  // To track conversarion
  conversation: Conversation = {
    id: uuidv4(),
    messages: [],
    date: ''
  };
  public onPromptSubmitComplete: Promise<void> = Promise.resolve();

  onPromptSubmit(promptEvent: any) {
    this.userPrompt = promptEvent.prompt;
    this.isFirstChunk = true; // Reset for new prompt
    this.responseMessage$.next(''); // Reset response message
    this.citations$.next([]); // Reset citations
    this.intent$.next(''); // Reset intent
    this.referenceCount$.next(0); // Reset reference count
    this.referenceLinks$.next([]); // Reset reference links
    this.specificText$.next('')

    const now = new Date();
    this.conversation.messages.push({
      "id": uuidv4(),
      "role": "user",
      "content": promptEvent.prompt,
      "date": now.toISOString()
    });
    this.conversation.messages.push({
      "id": '',
      "role": "assistant",
      "content": "",
      "date": now.toISOString(),
      "showFeedbackForm": false
    });
    const transformedArray = this.conversation.messages.map(item => {
      if (item.role === 'assistant') {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { citations, intent, showFeedbackForm, ...rest } = item;
        return rest;
      }
      return item;
    });

    const conversationApiPayload = {
      "messages": transformedArray,
      "index_name": this.id
    };
    this.chatWrapperComponent.promptInputNewComponent.responseGeneratedFlag = true;
    this.responseGeneratedFlag = true;
    let promise = this.askOurDocsV2Service.conversationApi(conversationApiPayload).then(async response => {

      if (response.status === 200 && response.body) {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;

        while (!done) {
          const { value, done: readerDone } = await reader.read();
          done = readerDone;
          buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
          buffer = this.processChunks(buffer);
        }
        if (done) {
            const citationIndex = [...new Set(this.conversation.messages[this.conversation.messages.length - 1].content
              .match(/\[(doc(\d+))]/g)
              ?.map(match => parseInt(match.match(/\d+/)?.[0] || '0') - 1))];
            const filteredCitations = citationIndex.map(index => this.citations$.value[index]).filter(Boolean);
          this.conversation.messages.push({
            "id": '',
            "role": "tool",
            "content": JSON.stringify({
              citations: filteredCitations,
              intent: this.intent$.value
            }),
            "date": now.toISOString()
          });
          this.conversation.messages[this.conversation.messages.length - 2] = {
            "id": '',
            "role": "assistant",
            "content": this.specificText,
            "date": now.toISOString(),
            "citations": filteredCitations,
            "intent": this.intent$.value
          };
          const data = {
            "conversation": this.conversation.messages,
            "conversationId": this.conversation.id,
            "indexName": this.repoDetails.internal_index_name,
            "promptCount": this.conversation.messages.filter(msg => msg.role === 'user').length,
            "title": featureFlags.clickableChatHistory ? this.conversation.messages[0].content.slice(0, 120) : this.conversation.messages[0].content.slice(0, 20)
          };
          this.scrollToBottom();
          this.askOurDocsV2Service.saveToDB(data);
        }

        this.chatWrapperComponent.promptInputNewComponent.responseGeneratedFlag = false;
        this.responseGeneratedFlag = false;

      } else {
        this.conversation.messages[this.conversation.messages.length - 1] = {
          "id": '',
          "role": "assistant",
          "content": 'Failed to generate response.',
          "date": now.toISOString(),
          "citations": this.citations$.value,
          "intent": this.intent$.value
        };
      }
      this.chatWrapperComponent.promptInputNewComponent.responseGeneratedFlag = false;
      this.responseGeneratedFlag = false;
    });
    this.onPromptSubmitComplete = promise;
    this.isChatInitiated = true;
    this.chatWrapperComponent.setPromptText('');

    setTimeout(() => {
      const responseBoxesArray = this.responseBoxes.toArray();
      const lastResponseBox = responseBoxesArray[responseBoxesArray.length - 1];
      if (lastResponseBox && lastResponseBox.nativeElement) {
        lastResponseBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }, 500);
  }

  processChunks(buffer: string): string {
    let boundary = buffer.indexOf('\n');
    while (boundary !== -1) {
      const chunk = buffer.slice(0, boundary).trim();
      buffer = buffer.slice(boundary + 1);
      if (chunk) {
        try {
          const parsedChunk = JSON.parse(chunk);

          if (this.isFirstChunk) {
            this.isFirstChunk = false;
            parsedChunk.choices?.forEach((choice: any) => {
              choice.messages?.forEach((message: any) => {
                if (message.role === 'tool') {
                  const toolContent = JSON.parse(message.content);
                  if (toolContent.citations) {
                    this.citations$.next(toolContent.citations);
                    this.referenceCount$.next(toolContent.citations.length);
                    this.referenceLinks$.next(toolContent.citations.map((citation: any) => citation.filepath || ''));
                  }
                  if (toolContent.intent) {
                    this.intent$.next(toolContent.intent);
                  }
                } else if (message.role === 'assistant') {
                  this.responseMessage$.next(message.content);
                }
              });
            });
          } else {
            parsedChunk.choices?.forEach((choice: any) => {
              choice.messages?.forEach((message: any) => {
                if (message.content) {
                  let currentSpecificText = this.specificText$.getValue();
                  currentSpecificText += message.content;
                  this.specificText$.next(currentSpecificText);
                  this.conversation.messages[this.conversation.messages.length - 1].content = currentSpecificText;
                }
              });
            });
          }
          this.scrollToBottom();
        } catch (e) {
          console.error('Failed to parse chunk:', chunk, e);
        }
      }
      boundary = buffer.indexOf('\n');
    }
    return buffer;
  }

  scrollToBottom() {
    const responseBoxesArray = this.responseBoxes.toArray();
    const lastResponseBox = responseBoxesArray[responseBoxesArray.length - 1];
    if (lastResponseBox && lastResponseBox.nativeElement) {
      const rect = lastResponseBox.nativeElement.getBoundingClientRect();
      const offset = 125;
      if (rect.top - offset > 0) {
        lastResponseBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }
  }

  replaceTagsWithSup(content: string): string {
    // Replace [doc<number>] with <sup><number></sup>
    content = content.replace(/\[doc(\d+)\]/g, (match, p1) => `<sup>${p1}</sup>`);

    // Ensure there is a space between two consecutive <sup> tags
    content = content.replace(/(<sup>\d+<\/sup>)(?=<sup>)/g, '$1 ');

    return content;
  }

  reorderDocReferences(content: string): string {
    const docRegex = /\[doc(\d+)\]/g;
    const docNumbers = new Set<number>();
    let match;
    while ((match = docRegex.exec(content)) !== null) {
        docNumbers.add(parseInt(match[1], 10));
    }

    const sortedDocNumbers = Array.from(docNumbers).sort((a, b) => a - b);

    const docMapping: { [key: number]: number } = {};
    sortedDocNumbers.forEach((num, index) => {
        docMapping[num] = index + 1;
    });

    const updatedContent = content.replace(docRegex, (match, p1) => `[doc${docMapping[parseInt(p1, 10)]}]`);

    return updatedContent;
  }

  copyAssistantPrompt(message: string) {
    this.clipboard.copyFromContent(message);
  };
  copyUserPrompt(message: string) {
    this.clipboard.copyFromContent(message);
  }

  repoDropdownTrigger() {
    this.showModelDropdown = !this.showModelDropdown;
    this.modelDropdown.toggleMenu();
  }

  isContextMenuOpen(isOpen: any) {
    this.showModelDropdown = isOpen;
  }

  closeDropdownMenu() {
    if (this.showModelDropdown) {
      this.showModelDropdown = !this.showModelDropdown;
      this.modelDropdown.toggleMenu();
    }
  }

  menuItemSelected(menuItem: any) {
    switch (menuItem.label) {
      case RepoChatDropdownMenuLabels.NEW_CHAT:
        this.startNewChat();
        break;

      case RepoChatDropdownMenuLabels.SAVED_PROMPTS:
        this.savedPromptsComponent.getSavedPromptsPrivate();
        this.savedPromptsComponent.getSavedPromptsPublic();
        this.showSavedPromptsModal();
        break;

      case RepoChatDropdownMenuLabels.HISTORY:
        this.showRepositoryHistory('repositoryHistory');
        break;

      case RepoChatDropdownMenuLabels.SOURCE_UPDATED:
        // this.showSourceDetails();
        break;

      case RepoChatDropdownMenuLabels.ABOUT_REPOSITORY:
        this.openAboutRepositoryModal();
        break;

      case RepoChatDropdownMenuLabels.REPOSITORY_SETTINGS:
        this.redirectToManagment();
        break;

      default:
    }
  }

  openAboutRepositoryModal() {
    this.kmdModalService.open('about-repository-modal');
  }

  closeModal() {
    this.kmdModalService.close('about-repository-modal');
  }

  startNewChat() {
    this.isChatInitiated = false;
    this.conversation = {
      id: uuidv4(),
      messages: [],
      date: ''
    };
  }

  getCitationLinkClass(): string {
    return this.enableCitationDownload ? 'enabled' : 'disabled';
  }

  showRepositoryHistory(id : string){
    if(this.isMobileScreen()) {
      this.showDialog()
    }
    else {
      this.kmdModalService.open(id);
    }
    this.chatHistoryComponent.tableDataRefresh();
  }

  closeRepositoryHistory(id : string){
    this.kmdModalService.close(id);
  }

  getFileType(link: string): string {
    const extension = link.split('.').pop()?.split('/')[0];
    return extension && extension !== link ? extension.toUpperCase() : '';
  }

  redirectToManagment() {
    const navigationExtras = {
      state: this.state
    };
    this.router.navigate([`../${this.id}/admin`, this.repositoryGroup], { ...navigationExtras, relativeTo: this.route });
  }

  openDrawer(citations: any): void {
    this.currentCitations = citations;
    this.drawerComponent.openDrawer();
  }

  closeDrawer(): void {
    this.drawerComponent.dismissDrawer();
  }

  toggleText(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  decodeLink(link: string): string {
    return decodeURIComponent(link);
  }

  replaceSpaces(title: string): string {
    return title.replace(/%20/g, ' ');
  }

  openSourceFile(citation: any): void {
    if (featureFlags.aodNewCitationViewer) {
      const viewer = new CitationViewer(
        this.askOurDocsV2Service,
        this.repoDetails,
        this.enableCitationDownload
      );
      viewer.openSourceFile(citation, this.isMobileScreen());
    } else {
      this.openSourceFileOld(citation);
    }
  }

  openSourceFileOld(citation: any): void {
    if (!this.enableCitationDownload) {
      return;
    }
    let fullUrl = '';
    this.askOurDocsV2Service.getSasToken(this.repoDetails.internal_index_name).then(response => {
      const { sas_token, base_url } = response;

      if (!citation.url) {
        // If the URL is blank, use the title to construct the full URL
        fullUrl = `${base_url}/${encodeURIComponent(citation.title || "default-title")}${sas_token}`;
      } else if (!citation.url.includes("blob.core")) {
        // If the URL is not blank but doesn't include "blob.core", prepend the base URL
        fullUrl = `${base_url}/${citation.url}${sas_token}`;
      } else {
        // If the citation URL already includes "blob.core", it might already be a full URL
        fullUrl = citation.url;
      }
      window.open(fullUrl, '_blank');
    }).catch(e => {
      console.log(e);
    });
  }

  openUri(citation: any): void {
    // For this user, the url refers to a Seismic URL, which will open a window to the Seismic platform.
    // Auth and perms will be managed by the Seismic platform. If other URLs are used in future, we may need to handle them differently.
    if(citation.url) {
      window.open(citation.url, '_blank');
    } else {
      window.open("", '_blank');
      console.error('No resource link available for this citation.');
    }
  }

  async conversationChatHistoryClicked(conversationHistory: any) {
    this.isChatInitiated = true;
    this.conversation.id = conversationHistory.id;
    this.chatWrapperComponent.promptInputNewComponent.responseGeneratedFlag = false;
    // We have 3 formats of data which are stored in DB through saveToDB API call
    if(typeof conversationHistory.conversation != 'string') {
      //Case 1: Treating it as JSON
      this.conversation.messages = conversationHistory.conversation;
      this.conversation.messages = this.conversation.messages.map(message => {
        if (message.role === 'assistant') {
          message.showFeedbackForm = false;
        }
        return message;
      });
    } else {
      try {
        // Case 2: Trying to treat it as a stringified JSON and parse the JSON string
        const parsedConversation = JSON.parse(conversationHistory.conversation);
        this.conversation.messages = parsedConversation;
      } catch {
        // Case 3: If parsing fails, treating it as normal string
        this.conversation.messages = this.convertConversationToJson(conversationHistory.conversation);
      }
    }
    this.closeRepositoryHistory('repositoryHistory');
    this.closeDialog();
  }

  convertConversationToJson(conversationString: string): any[] {
    const conversation: any[] = [];
    const messages = conversationString.split('\n');
    let currentMessage = '';
    let currentRole = '';
    const currentDate = new Date().toISOString();

    // Helper function to add message to conversation array
    const addMessageToConversation = (role: string, content: string) => {
        if (content.trim()) {
            conversation.push({
                id: role === 'user' ? crypto.randomUUID() : '',
                role: role,
                content: content.trim(),
                date: currentDate
            });

            // Add tool message after assistant message
            if (role === 'assistant') {
                conversation.push({
                    id: '',
                    role: 'tool',
                    content: JSON.stringify({
                        citations: [],
                        intent: '[]'
                    }),
                    date: currentDate
                });
            }
        }
    };

    // Processing each line
    messages.forEach((line, index) => {
        if (line.startsWith('user: ')) {
            // If there was a previous message, add it
            if (currentRole && currentMessage) {
                addMessageToConversation(currentRole, currentMessage);
            }
            currentRole = 'user';
            currentMessage = line.substring(6); // Removing 'user: '
        } else if (line.startsWith('assistant: ')) {
            // If there was a previous message, then adding it
            if (currentRole && currentMessage) {
                addMessageToConversation(currentRole, currentMessage);
            }
            currentRole = 'assistant';
            currentMessage = line.substring(11); // Remove 'assistant: '
        } else {
            // Appending to current message if it's a continuation
            if (currentMessage && line) {
                currentMessage += '\n' + line;
            }
        }

        // If this is the last line, then we are adding the final message
        if (index === messages.length - 1 && currentRole && currentMessage) {
            addMessageToConversation(currentRole, currentMessage);
        }
    });

    return conversation;
  }

  isMobileScreen(): boolean {
    return (500 >= WindowRef.innerWidth);
  }

  showDialog() {
    this.chatHistoryVisible = true;
  }

  closeDialog() {
    this.chatHistoryVisible = false;
  }

  onDrawerStateChange(event:any){
    this.isAppDrawerOpen = event === 'in';
  }

  showSavedPromptsModal() {
    if(this.isMobileScreen()) {
      this.savedPromptsVisible = true;
      this.isDetailModalOpen = false;
    }
    else {
      this.isDetailModalOpen = false;
      this.kmdModalService.open('saved-prompts-modal');
    }
  }

  closeMobileSavedPrompts() {
    this.savedPromptsVisible = false;
  }

  setSavedPromptsModalHeadline(headline: any) {
    this.isDetailModalOpen = headline;
  }

  showSaveCurrentPromptModal(prompt: string) {
    this.kmdModalService.open('save-current-prompt-modal');
    this.savePromptComponent.setCurrentPrompt(prompt);
  }

  savedPromptsModalClosed(modalId: string) {
    if(modalId === 'saved-prompts-modal') {
      this.savedPromptsComponent.closeSavedPromptDetailModal();
    }
  }

  promptInNewChatTrigger(prompt: string) {
    this.startNewChat();
    this.chatWrapperComponent.setPromptText(prompt)
  }

  promptTrigger(prompt: string) {
    this.chatWrapperComponent.setPromptText(prompt)
  }

  setEachRepositoriesOwners = (repositories: { content: any[] }) => {
    let resolvedOwnerCounter = 0;

    const repoContent = repositories.content;

    if (repoContent.length === 0) {
      this.isInfoLoading = false;
      this.hasRepositories = false;
      return;
    }

    repoContent.forEach((repository: { name: string, isAdmin: boolean }) => {
      if (repository.isAdmin && !this.isUserRepoAdmin) {
        this.isUserRepoAdmin = true
      }

      this.getRepoOwners(repository)
        .pipe(
          tap((owners: string) => {
            this.repoOwnersDictionary.push({
              key: repository.name,
              owners: owners,
              isAdmin: repository.isAdmin
            })
          }),
          finalize(() => {
            resolvedOwnerCounter++;
            if (resolvedOwnerCounter === repositories.content.length) {
              this.isInfoLoading = false;
              this.hasRepositories = true;
            }
          })
        )
        .subscribe();
    });
    const initialRepositories$ = this.askOurDocsService.pagedRoleRepositories('', 0, 15, "All repositories");
    initialRepositories$.subscribe(repositories => {
      this.fetchGroupByRepository(repositories.content[0].name);
    });
  };

  getRepoOwners(repository: any): Observable<string> {
    return this.groupMembershipService.getGroupByRepository(repository.name).pipe(
      filter(group => group && group.response.value),
      mergeMap(group => {
        let owners$: any;

        const repoInfo = group.response.value;

        if (repoInfo.length === 0) {
          owners$ = this.groupMembershipService.getGroupOwners(this.aodSuperAdminId)
          this.repoGroupsDictionary.push({ key: repository.name, id: this.aodSuperAdminId });
        } else {
          const cleanedRepoName = repository.id.replace("dpe_geneai_index_", "").replace(/[.]/g, '');

          owners$ = repoInfo
            .map((group: any) => (group.displayName === cleanedRepoName) ? group.id : this.aodSuperAdminId)
            .map((groupId: string) => this.groupMembershipService.getGroupOwners(groupId));

          repoInfo
            .filter((group: any) => group.displayName === cleanedRepoName)
            .forEach((group: any) => this.repoGroupsDictionary.push({ key: repository.name, id: group.id }));
        }

        return forkJoin(owners$);
      }),
      map((ownersArray: any) => {
        const allOwners = ownersArray.flatMap((owners: any) => owners.value);

        return Array.from(new Set(allOwners.map(
          (owner: { userPrincipalName: any }) => owner.userPrincipalName
        )))
          .sort((a: any, b: any) => a.toLowerCase().localeCompare(b.toLowerCase()))
          .join(", ");
      })
    );
  };

  fetchGroupByRepository = (repositoryName: string): string => {
    const cleanedRepoName = repositoryName.replace("dpe_geneai_index_", "");
    const normalizedRepoName = cleanedRepoName.replace(/_/g, ' ');
    const item = this.repoGroupsDictionary.find(obj => obj.key === normalizedRepoName);
    this.repositoryGroup = this.repoGroupsDictionary[0].id;
    this.state.repositoryGroup = this.repoGroupsDictionary[0].id;
    if(item){
      this.repositoryGroup = item.id;
    }
    return item ? item.id : '';
  };

  getAODUrlPath(indexName: string) {
    return this.aodUrl + indexName;
  }

  extractLastSegmentRepoId() {
    const url = this.router?.url || '';
    const urlSegments = url.split('/').filter(segment => segment);
    const lastSegment = urlSegments[urlSegments.length - 1];
    return lastSegment;
  }
}
